// # Mistake Counter Component for Step 2
import React from 'react';
import { useNavigate } from 'react-router-dom';
import SharedHeader from '../../../components/SharedHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import './counter2.css';
import { useAuthStore } from '../../../auth/state';
import { useState, useEffect } from 'react';

// # Import icons from my_notes.js structure
import heartIcon from '../../../general/library/step1/step1_icons/heart.png';
import lungsIcon from '../../../general/library/step1/step1_icons/lungs.png';
import kidneyIcon from '../../../general/library/step1/step1_icons/kidney.png';
import endocrineIcon from '../../../general/library/step1/step1_icons/endocrine.png';
import bloodIcon from '../../../general/library/step1/step1_icons/blood.png';
import immunologyIcon from '../../../general/library/step1/step1_icons/immunology.png';
import gitIcon from '../../../general/library/step1/step1_icons/git.png';
import musculoskeletalIcon from '../../../general/library/step1/step1_icons/musculoskeletal.png';
import cnsIcon from '../../../general/library/step1/step1_icons/cns.png';
import eyeIcon from '../../../general/library/step1/step1_icons/eye.png';
import psychiatryIcon from '../../../general/library/step1/step1_icons/psychiatry.png';
import skinIcon from '../../../general/library/step1/step1_icons/skin.png';
import reproductiveIcon from '../../../general/library/step1/step1_icons/reproductive-system.png';
import revisionIcon from '../../../general/library/step1/step1_icons/revision.png';
import biochemistryIcon from '../../../general/library/step1/step1_icons/biochemistry.png';
import infectiousIcon from '../../../general/library/step1/step1_icons/infectious.png';
import publicHealthIcon from '../../../general/library/step1/step1_icons/public_health.png';
import pharmaIcon from '../../../general/library/step1/step1_icons/pharma.png';

function Counter2({ isAdmin }) {
  const navigate = useNavigate();
  const { user } = useAuthStore();
  const [targetUserId, setTargetUserId] = useState(null);
  const [isMentor, setIsMentor] = useState(false);

  // # Get the correct user ID (mentee's ID when mentor is viewing)
  useEffect(() => {
    const menteeId = sessionStorage.getItem('currentViewingMenteeId');
    setTargetUserId(menteeId || user?.uid);
    setIsMentor(!!menteeId);
  }, [user?.uid]);

  // # Define chapters based on my_notes.js Step 2 structure
  const chapters = [
    { id: 'Cardiovascular', title: 'Cardiovascular', icon: heartIcon },
    { id: 'Respiratory & ENT', title: 'Respiratory & ENT', icon: lungsIcon },
    { id: 'Renal & Urology', title: 'Renal & Urology', icon: kidneyIcon },
    { id: 'Endocrine', title: 'Endocrine', icon: endocrineIcon },
    { id: 'Hematology & Oncology', title: 'Hematology & Oncology', icon: bloodIcon },
    { id: 'Immunology', title: 'Immunology', icon: immunologyIcon },
    { id: 'Gastrointestinal', title: 'Gastrointestinal', icon: gitIcon },
    { id: 'Musculoskeletal', title: 'Musculoskeletal', icon: musculoskeletalIcon },
    { id: 'Neurology', title: 'Neurology', icon: cnsIcon },
    { id: 'Ophthalmology', title: 'Ophthalmology', icon: eyeIcon },
    { id: 'Psychiatry', title: 'Psychiatry', icon: psychiatryIcon },
    { id: 'Dermatology', title: 'Dermatology', icon: skinIcon },
    { id: 'Obstetrics & Gynecology', title: 'Obstetrics & Gynecology', icon: reproductiveIcon },
    { id: 'Pediatrics & Neonatology', title: 'Pediatrics & Neonatology', icon: revisionIcon },
    { id: 'Genetics', title: 'Genetics', icon: biochemistryIcon },
    { id: 'Infectious Disease', title: 'Infectious Disease', icon: infectiousIcon },
    { id: 'Surgery & Anesthesia', title: 'Surgery & Anesthesia', icon: revisionIcon },
    { id: 'Emergency Medicine & Trauma', title: 'Emergency Medicine & Trauma', icon: revisionIcon },
    { id: 'Well-Patient', title: 'Well-Patient', icon: revisionIcon },
    { id: 'Biostatistics & Epidemiology', title: 'Biostatistics & Epidemiology', icon: revisionIcon },
    { id: 'Ethics & Communication Skills', title: 'Ethics & Communication Skills', icon: publicHealthIcon },
    { id: 'Healthcare Delivery', title: 'Healthcare Delivery', icon: revisionIcon },
    { id: 'Quality & Safety', title: 'Quality & Safety', icon: revisionIcon },
    { id: 'Pharmacology Review', title: 'Pharmacology Review', icon: pharmaIcon }
  ];

  // # Handle back navigation
  const handleBack = () => {
    const basePath = isAdmin ? '/admin/mentorship' : '/mentorship';
    navigate(`${basePath}/step2`);
  };

  // # Handle chapter click
  const handleChapterClick = (chapterId) => {
    const basePath = isAdmin ? '/admin/mentorship' : '/mentorship';
    navigate(`${basePath}/step2/mentoring2/counter2/${chapterId}`);
  };

  return (
    <div className="counter2_container">
      {/* # Header */}
      <SharedHeader />

      <div className="counter2_content">
        <div className="counter2_header">
          <button className="counter2_back_button" onClick={handleBack}>
            &larr; Back to Dashboard
          </button>
          <h1>USMLE Step 2 Chapters</h1>
          {isMentor && <span className="counter2_mentor_pill">Mentor</span>}
        </div>

        <div className="counter2_chapters_grid">
          {chapters.map(chapter => (
            <div 
              key={chapter.id} 
              className="counter2_chapter_card"
              onClick={() => handleChapterClick(chapter.id)}
            >
              <div className="counter2_chapter_header">
                <img src={chapter.icon} alt={chapter.title} className="counter2_chapter_icon" />
                <h3>{chapter.title}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* # Footer */}
      <DashboardFooter />
    </div>
  );
}

export default Counter2;
